import { createStore } from "vuex";

import actions from "./actions";
import mutations from "./mutations";
import user from "./modules/user";
import loading from "./modules/loading";
import confirmapi from "./modules/confirm-api";
import alertMessage from "./modules/alert-message";
import aggregation from "./modules/aggregation";
import properties from "./modules/properties";
import newMails from "./modules/new-mails";

const store = createStore({
  modules: {
    user,
    loading,
    confirmapi,
    alertMessage,
    aggregation,
    properties,
    newMails,
  },
  mutations,
  actions,
});

export default store;
